import EventsBox from "components/company/v3/boxes/EventsBox";
import type { CompanyEventsTabEnum } from "components/company/v3/menu/enums";
import type { EventsCalendarState } from "components/investorrelations/EventsCalendarLocalState";
import { IIssuerType } from "types/graphqlTypes";

interface BrazilianEventsBoxProps extends EventsCalendarState {
  tickerSymbol: string;
  isRenderPageDefault?: boolean;
  tab: CompanyEventsTabEnum;
  onChangeTab: (tab: CompanyEventsTabEnum) => void;
}

export default function BrazilianEventsBox({
  tickerSymbol,
  isRenderPageDefault = false,
  tab,
  onChangeTab,
  ...filterState
}: BrazilianEventsBoxProps) {
  return (
    <EventsBox
      tickerSymbol={tickerSymbol}
      context="ACOES"
      isRenderPageDefault={isRenderPageDefault}
      tab={tab}
      onChangeTab={onChangeTab}
      {...filterState}
      issuerType={IIssuerType.BrazilianCompany}
    />
  );
}
